import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';

import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

import EditAddressModal from './edit-shipto-modal';
import FedexHalShipmentTooltip from '../../../../../../fulfillment-planner/shipping-service/fedex-hal-shipment-tooltip';
import PickupRelayTooltip from '../../../../../../orders/customer-recipient-widget/pickup-relay-tooltip';
import { useIsFedexHALByFulfillmentPlanId } from '../../../../../../hooks/orders/use-fedex-hal-check';
import { useIsFulfillmentPlanShipToUpdatable } from './use-shipment-details-address';
import { useIsPickupRelayOrderByFulfillmentPlanId } from '../../../../../../hooks/orders/use-pickup-relay-order-check';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useModal } from '../../../../../../hooks/use-modal';

import messages from '../messages';
import style from './address.module.less';

const ShipToLabel = ({ isLocked = false }) => {
  const { open: openEditModal, close, isOpen } = useModal();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const showEditAction = useIsFulfillmentPlanShipToUpdatable(fulfillmentPlanId);
  const isFedexHalShipment = useIsFedexHALByFulfillmentPlanId(fulfillmentPlanId);
  const isPickupRelayOrder = useIsPickupRelayOrderByFulfillmentPlanId(fulfillmentPlanId);

  return (
    <>
      <FormattedMessage {...messages.shipToAddress} />
      <div className={style['address-label-actions']}>
        {isLocked && (
          <div className={style['lock-icon']}>
            <FontAwesomeIcon icon={faLock} />
          </div>
        )}
        {showEditAction && (
          <Button
            className={buttonTextStyle['button-text']}
            disabled={isFedexHalShipment || isPickupRelayOrder}
            onClick={openEditModal}
            theme='link'
          >
            <FormattedMessage {...messages.editShipToAddressButton} />
          </Button>
        )}
        {isFedexHalShipment && (
          <FedexHalShipmentTooltip iconClassName={style.icon} iconContainerClassName={style['icon-container']} isAddressTooltip />
        )}
        {isPickupRelayOrder && <PickupRelayTooltip iconClassName={style.icon} tooltipTargetWrapperClassName={style['icon-container']} />}
      </div>
      {isOpen && <EditAddressModal onClose={close} />}
    </>
  );
};

ShipToLabel.propTypes = {
  isLocked: PropTypes.bool,
};

export default ShipToLabel;
